import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import { getPlants } from "../../api/api_plant"
import PlantsPeriodsGraph from "../../Component/Plant/PlantsPeriodsGraph"

class GGPlantsPeriods extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)
    this.state = {
      isReadyToRender: false,
      entities: [],
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)
  }

  componentDidMount() {
    this.getEntities()
  }

  async getEntities() {
    // CONFIG ------------------------------------------------------------------------------------------------
    let parameters = { itemsPerPage: 10000 }
    let entities = await getPlants(parameters)
    // / CONFIG ----------------------------------------------------------------------------------------------

    this.setState({ isReadyToRender: true, entities: entities["hydra:member"] })
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <>
        <br />
        <div className="text-center">
          <PlantsPeriodsGraph key="graphPeriod-all" plants={this.state.entities} />
        </div>
      </>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(GGPlantsPeriods)
